"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.savePendingSpanTargets = savePendingSpanTargets;
const tslib_1 = require("tslib");
const index_1 = require("../index");
/**
 * Save all target collections that have been modified by span link/unlink operations.
 * Each target is saved with a `spanLinkedPoleUuid` modification pointing to the source collection.
 *
 * After each successful target save, `finishEdit()` is called on the
 * target collection to drop its proxy state.
 *
 * This function should be called AFTER the source collection has been
 * saved successfully. If the source save failed, do not call this.
 */
function savePendingSpanTargets(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { sourceCollection, targetCollections } = options;
        const savedTargetIds = [];
        const failedTargetIds = [];
        for (const targetCollection of targetCollections) {
            const targetId = targetCollection.id;
            try {
                yield index_1.Services.Collection.save(targetCollection, {
                    spanLinkedPoleUuid: sourceCollection.uuid,
                });
                targetCollection.finishEdit();
                savedTargetIds.push(targetId);
            }
            catch (error) {
                index_1.Services.Log.Logger.error(`Failed to save target collection ${targetId} after span link: ${error}`);
                failedTargetIds.push(targetId);
            }
        }
        return { savedTargetIds, failedTargetIds };
    });
}
//# sourceMappingURL=save.pending.span.targets.js.map